import { FleekError } from './FleekError';

type UploadProxyStoreAsCarErrorOptions = Record<string, never>;

export class UploadProxyStoreAsCarError extends FleekError<UploadProxyStoreAsCarErrorOptions> {
  public name = 'UploadProxyStoreAsCarError';

  constructor() {
    super({});
  }

  toString = () => `Failed to Store as a CAR file.`;
}
